import { Box, Divider, Stack, Text } from '@mantine/core';
import { useMemo } from 'react';

import { buildAmendmentVersions, Declaration } from '@e-origin/shared';

import { AmendmentSectionView } from './AmendmentSectionView';

interface AmendmentModalProps {
  declaration: Declaration;
}

export const AmendmentModal: React.FC<AmendmentModalProps> = ({ declaration }) => {
  const versionGroups = useMemo(() => {
    const amendments = declaration.customsState?.amendment?.details ?? [];
    return buildAmendmentVersions([{ sequence: declaration.goodShipmentGlobal.sequence, amendments }]);
  }, [declaration]);

  return (
    <Stack>
      {versionGroups.map(({ version, header, items }, idx) => (
        <Box key={version}>
          {idx > 0 && <Divider my="md" />}
          <Text fw={700} size="lg" mb="xs">
            Version {version}
          </Text>
          {(header.additionalInformation.length > 0 || header.changes.length > 0) && <AmendmentSectionView label="Header" bucket={header} />}
          {items.map((item) => (
            <AmendmentSectionView key={item.sequence} label="" bucket={item} />
          ))}
        </Box>
      ))}
    </Stack>
  );
};
